import React from 'react'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem3,
    GridItem3sm6xs6,
    GridItem9,
    GridItem9sm12xs12,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGrid,
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'
 
import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import comSemDiaDiaEstudoList from '../../../business-rules/List/comSemDiaDiaEstudoList'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    calculaIntervaloTempoAnosMesesMorteAteVitalicio,
} from '../cliente-form/ClienteService'

import {
    GridContainerEstudoPadraoLg,
} from '../estudo-form/EstudoComp'

import {
    graficoPossuiValor
} from '../estudo-form/EstudoServiceCalculo'

import {
    serieVazia
} from './ChartService'

import {
    processaValoresDefaultIniciaisDespesasAcumuladasChart,
} from './DespesasAcumuladasChartService'



const DespesasAcumuladasChart = ( { values, handleChange, estudo, comSemDiaDiaEstudo, naoExibirDespesasAcumuladasSemDiaDia,  report } ) => {

    processaValoresDefaultIniciaisDespesasAcumuladasChart(values)

    const GridItem9sm12xs12DespesasAcumuladasMorteInvalidezChart = report ? GridItem9 : GridItem9sm12xs12
    const GridItem3sm6xs6DespesasAcumuladasMorteInvalidezChart = report ? GridItem3 : GridItem3sm6xs6

    const DespesasAcumuladas = ( /*props*/ ) => {

        if (comSemDiaDiaEstudo) {
            values.comSemDiaDiaEstudo = comSemDiaDiaEstudo
        }
    
        if (values.naoExibirDespesasAcumuladasSemDiaDia) {
    
            values.comSemDiaDiaEstudo = HARDCODE.comSemDiaDiaEstudoCom
        }
    
        const series = []

        const paletaCores = []//values.comSemDiaDiaEstudo === HARDCODE.comSemDiaDiaEstudoCom ? paletaCores3 : paletaCores2
    
        if (values.comSemDiaDiaEstudo === HARDCODE.comSemDiaDiaEstudoCom) {
    
            /*
            if (graficoPossuiValor(estudo.current.graficoSucessaoVitalicia)) {

                series.push(
                    {
                        name: LABEL.sucessaoVitalicia,
                        type: 'bar',
                        data: estudo.current.graficoSucessaoVitalicia,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasSucessaoVitalicia)
            }
            */
    
            if (graficoPossuiValor(estudo.current.graficoDiaDiaDespesasVitalicias)) {

                series.push(
                    {
                        name: LABEL.diaDia,
                        type: 'bar',
                        data: estudo.current.graficoDiaDiaDespesasVitalicias,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasDespesasVitalicias)
            }
    
            if (graficoPossuiValor(estudo.current.graficoProjetoVidaSonho)) {

                series.push(
                    {
                        name: LABEL.projetoVidaSonho,
                        type: 'bar',
                        data: estudo.current.graficoProjetoVidaSonho,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasProjetoVidaSonho)
            }

        } else {
    
            /*
            if (graficoPossuiValor(estudo.current.graficoSucessaoVitalicia)) {

                series.push(
                    {
                        name: LABEL.sucessaoVitalicia,
                        type: 'bar',
                        data: estudo.current.graficoSucessaoVitalicia,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasSucessaoVitalicia)
            }
            */
            
            if (graficoPossuiValor(estudo.current.graficoProjetoVidaSonho)) {

                series.push(
                    {
                        name: LABEL.projetoVidaSonho,
                        type: 'bar',
                        data: estudo.current.graficoProjetoVidaSonho,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasProjetoVidaSonho)
            }
        }
        
        if (graficoPossuiValor(estudo.current.graficoEducacao)) {

            series.push(
                {
                    name: LABEL.educacao,
                    type: 'bar',
                    data: estudo.current.graficoEducacao,
                },
            )

            paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasEducacao)
        }
    
        if (graficoPossuiValor(estudo.current.graficoFinanciamento)) {

            series.push(
                {
                    name: LABEL.financiamento,
                    type: 'bar',
                    data: estudo.current.graficoFinanciamento,
                },
            )

            paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasFinanciamento)
        }
    
        if (graficoPossuiValor(estudo.current.graficoDiaDiaDespesasTemporarias)) {

            series.push(
                {
                    name: LABEL.diaDiaDespesasTemporariasDescricaoCurta,
                    type: 'bar',
                    data: estudo.current.graficoDiaDiaDespesasTemporarias,
                },
            )

            paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasDespesasTemporarias)
        }

        serieVazia(series, estudo)
    
        const categories = estudo.current.graficoIdadesGraficos
    
        const GridGrafico = report ? GridItem11 : GridItem11

        return (
            //<div
            //    {...props}
            //>
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={
                                //LABEL.despesasAcumuladasLongoTempo + // mudança da fonte
                                    (!values.naoExibirDespesasAcumuladasSemDiaDia && !naoExibirDespesasAcumuladasSemDiaDia
                                        ?
                                            /*': ' + mudança da fonte*/pesquisaList(comSemDiaDiaEstudoList,
                                                values.comSemDiaDiaEstudo).descricao
                                        :
                                            ''
                                    )
                            }
                            type='area'//"bar"
                            series={series}
                            height={report && values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioPaisagem ? 300 : ''}
                            stacked={true}
                            categories={categories}
                            categories2={estudo.current.graficoAnos}
                            paletaCores={paletaCores}
                            dataLabelsEnabled={values.modoApresentacao}
                            dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao || values.modoApresentacao}
                            dataLabelsType='Idade'
                            dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                            columnWidth='80%'
                            toolTipX={true}
                            toolTipXTotal={true}
                            report={report}
                            formatoReport={values.formatoReport}
                            modoApresentacao={values.modoApresentacao}
                            fillOpacity={0.7}//0.9
                            participacao={true}
                        />
                    </GridGrafico>
                </GridContainer>
            //</div>
        )
    }



    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo

    const ComSemDiaDiaEstudo = () => {

        return (
            <GridContainer>
                <GridItem12>
                    <TextFieldTextSelect
                        name="comSemDiaDiaEstudo"
                        label={LABEL.comSemDiaDiaEstudo}
                        value={values.comSemDiaDiaEstudo || ''}
                        onChange={handleChange}
                        list={comSemDiaDiaEstudoList}
                    />
                </GridItem12>
            </GridContainer>
        )
    }



    return (
        <GridItem12>
            {report
                ?
                    <div
                        className='mt-5'
                    >
                        <DespesasAcumuladas
                            //className='mt--0 ml-5' // mudança da fonte: mt-5
                        />
                    </div>
                :
                    <GridContainerEstudoPadraoLg
                        component={
                            <div
                                className={values.modoApresentacao ? 'mt--5' : ''}
                            >
                                <CardGridEstudoAux>
                                    <CardGridDivHeaderDestaque1
                                        semBackground={values.modoApresentacao}
                                    >
                                        <GridContainer>
                                            <GridItem9sm12xs12DespesasAcumuladasMorteInvalidezChart>
                                                <CardGridDivH4Destaque>
                                                    {LABEL.despesasAcumuladasLongoTempo}
                                                </CardGridDivH4Destaque>
                                                <div
                                                    className="text-18 text-muted font-light mt-2"
                                                >
                                                    {calculaIntervaloTempoAnosMesesMorteAteVitalicio(values)}
                                                </div>
                                            </GridItem9sm12xs12DespesasAcumuladasMorteInvalidezChart>
                                            
                                            {!values.naoExibirDespesasAcumuladasSemDiaDia && (
                                                <GridItem3sm6xs6DespesasAcumuladasMorteInvalidezChart>
                                                    {values.modoApresentacao
                                                        ?
                                                            <ComSemDiaDiaEstudo/>
                                                        :
                                                            <CardGrid>
                                                                <CardGridDivBodyEntradaDados>
                                                                    <ComSemDiaDiaEstudo/>
                                                                </CardGridDivBodyEntradaDados>
                                                            </CardGrid>
                                                    }
                                                </GridItem3sm6xs6DespesasAcumuladasMorteInvalidezChart>
                                            )}
                                        </GridContainer>
                                    </CardGridDivHeaderDestaque1>

                                    <CardGridDivBody>
                                        <div
                                            className='ml-10'
                                        >
                                            <DespesasAcumuladas/>
                                        </div>
                                    </CardGridDivBody>
                                </CardGridEstudoAux>
                            </div>
                        }
                    />
            }
        </GridItem12>
    )
}

export default DespesasAcumuladasChart